import { createSelector } from 'reselect';

export const getChat = ({ chat }) => chat.data;

export const getThread = ({ chat }) => chat.data.thread;

export const getHasThread = createSelector(
  getThread,
  thread => thread.length > 0,
);

export const getIsLoading = ({ chat }) => chat.isLoading;

export const getIsOpen = ({ chat }) => chat.isOpen;

export const getHasError = ({ chat }) => chat.error !== '';

export const getError = ({ chat }) => chat.error;
